import { Provider } from '@angular/core';
import { SentryConfig } from '../../models/sentry-config/sentry-config.model';
import { SENTRY_CONFIG } from './sentry-config.token';

export const provideSentryConfig = (config?: SentryConfig): Provider => ({
    provide: SENTRY_CONFIG,
    useValue: config ?? {},
});
